import { render } from "./ImpressumPage.vue?vue&type=template&id=758aee12&scoped=true"
import script from "./ImpressumPage.vue?vue&type=script&lang=js"
export * from "./ImpressumPage.vue?vue&type=script&lang=js"

import "./ImpressumPage.vue?vue&type=style&index=0&id=758aee12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758aee12"]])

export default __exports__